function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Czech Republic");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Czech-Republic",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "LS/Assets/SVG's/Circle/Flag/Czech-Republic",
  transform: "translate(-0.000000, -1.000000)"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M1023.93141,521.466856 C1019.58417,789.591884 809.131845,1007.61482 544.100033,1024.01008 L479.899967,1024.01008 C212.083837,1007.44258 0,784.988708 0,513 C0,512.665994 0.000319827144,512.332062 0.00095919189,511.998205 L1023.992,511.999205 L1024,512.999205 Z",
  id: "Combined-Shape",
  fill: "#D7131A"
}), React.createElement("path", {
  d: "M1024,1 L512,1 C794.769792,1 1024,230.230208 1024,513 L1023.992,512 L0.000958965365,511.998324 C0.536129822,232.515491 225.001208,5.5845642 503.533144,1.06859337 L512,1 L0,1 L0,0 L1024,0 L1024,1 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
}), React.createElement("path", {
  d: "M0,513 C0,407.746127 31.76011,309.910225 86.219587,228.553036 L512,512.5 L85.756688,796.754221 C31.580181,715.534664 0,617.955305 0,513 Z",
  id: "Combined-Shape",
  fill: "#10457E"
}))));

var SvgCzech = function SvgCzech(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCzech, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/czech.0d1d5989.svg";
export { ForwardRef as ReactComponent };